import reducer from "./reducer";
export { default as Alerts } from "./components/index";
export { default as alertsReducerName } from "./constants";
export default reducer;
